"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.system = exports.classesStyles = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _memoize = _interopRequireDefault(require("@emotion/memoize"));

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _shouldForwardProp = _interopRequireDefault(require("@styled-system/should-forward-prop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var classesStyles = function classesStyles(prop) {
  return function (props) {
    var _props$classes = props.classes,
        classes = _props$classes === void 0 ? {} : _props$classes;
    var styles = classes[prop];
    return typeof styles === 'function' ? (0, _css["default"])(styles(props)) : (0, _css["default"])(styles);
  };
};

exports.classesStyles = classesStyles;

var system = function system() {
  return (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.layout, _styledSystem.flexbox, _styledSystem.grid, _styledSystem.background, _styledSystem.border, _styledSystem.position, _styledSystem.shadow);
};

exports.system = system;
var allowedProps = ['activeClassName', 'exact'];

var styledBox = function styledBox() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var _config$shouldForward = config.shouldForwardProp,
        shouldForwardProp = _config$shouldForward === void 0 ? function () {
      return true;
    } : _config$shouldForward;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ( /*#__PURE__*/0, _base["default"])(element, process.env.NODE_ENV === "production" ? {
      shouldForwardProp: (0, _memoize["default"])(function (prop) {
        return allowedProps.includes(prop) || (0, _shouldForwardProp["default"])(prop) && shouldForwardProp(prop);
      }),
      target: "ebiai8r0"
    } : {
      shouldForwardProp: (0, _memoize["default"])(function (prop) {
        return allowedProps.includes(prop) || (0, _shouldForwardProp["default"])(prop) && shouldForwardProp(prop);
      }),
      target: "ebiai8r0",
      label: "styledBox"
    }).apply(void 0, args.concat([system()]));
  };
};

var _default = styledBox;
exports["default"] = _default;

//# sourceMappingURL=index.js.map